import React from 'react';

import { Button } from '@getethos/ethos-design-system-v2';

import { ButtonProps } from '@getethos/ethos-design-system-v2/dist/components/Button/Button';
import classNames from 'classnames';
import styles from './styles.module.scss';

const NoraButton = ({
  className,
  children,
  variant = 'primary',
  ...rest
}: Omit<ButtonProps, 'children' | 'buttonTitle' | 'variant'> & {
  children: string;
  variant?: ButtonProps['variant'];
}) => (
  <Button
    className={classNames(styles.NoraButton, className)}
    buttonTitle={children}
    variant={variant}
    {...rest}
  />
);

export default NoraButton;
